import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Navcomp.css';

const Navcomp = () => {
  return (
    <div>


      <Container>
        <Navbar className="color-nav" expand="lg"  >

          <Navbar.Brand href="#home">
            <img
              className="germlogo"
              src="./assets/images/logo.png"
              alt="logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/services">Services</Nav.Link>
              <Nav.Link href="/projects">Projects</Nav.Link>
              <Nav.Link href="/contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>

    </div>
  );
};

export default Navcomp;